var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMediumGreyArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_120_22939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3687 10.3332C21.2853 10.1183 21.1604 9.92195 21.001 9.75545L12.2474 1.00181C12.0841 0.838578 11.8904 0.709093 11.6771 0.62075C11.4638 0.532408 11.2352 0.486938 11.0044 0.486938C10.5381 0.486938 10.091 0.672144 9.76135 1.00181C9.59811 1.16505 9.46863 1.35884 9.38029 1.57211C9.29194 1.78539 9.24648 2.01398 9.24648 2.24483C9.24648 2.71105 9.43168 3.15818 9.76135 3.48785L15.5387 9.24774H2.25073C1.78641 9.24774 1.3411 9.43219 1.01278 9.76052C0.684451 10.0888 0.5 10.5341 0.5 10.9985C0.5 11.4628 0.684451 11.9081 1.01278 12.2364C1.3411 12.5647 1.78641 12.7492 2.25073 12.7492H15.5387L9.76135 18.5091C9.59726 18.6718 9.46701 18.8655 9.37813 19.0788C9.28925 19.2922 9.24349 19.521 9.24349 19.7521C9.24349 19.9832 9.28925 20.2121 9.37813 20.4254C9.46701 20.6387 9.59726 20.8324 9.76135 20.9951C9.9241 21.1592 10.1177 21.2895 10.3311 21.3783C10.5444 21.4672 10.7732 21.513 11.0044 21.513C11.2355 21.513 11.4643 21.4672 11.6777 21.3783C11.891 21.2895 12.0846 21.1592 12.2474 20.9951L21.001 12.2415C21.1604 12.075 21.2853 11.8786 21.3687 11.6637C21.5438 11.2375 21.5438 10.7594 21.3687 10.3332Z",
    fill: "#404040"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_120_22939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMediumGreyArrowRight);
export default __webpack_public_path__ + "static/media/Icon-Medium-Grey-Arrow-right.f0ad2930a3634b83ff14b33de98bcc63.svg";
export { ForwardRef as ReactComponent };